module.exports = __webpack_public_path__ + "assets/de5985677baa9e9205b3f34fc5655d84.svg";